import { LitElement, html } from "lit-element";
import WebMidi from "webmidi";
import { scale } from "../utils/utils";
import "./midi-in";

class MidiContainer extends LitElement {
  static get properties() {
    return {
      availableInputs: { type: Array },
    };
  }

  constructor() {
    super();

    this.avaialbleInputs;

    // web midi setup
    WebMidi.enable((error) => {
      if (error) {
        console.log(error);
      } else {
        this.availableInputs = WebMidi.inputs.map((input) => {
          const {
            _midiInput: { name },
          } = input;
          return name;
        });
        // set up IAC Bus 1 CC
        // const IACBus01 = WebMidi.getInputByName("IAC Driver Bus 1");
        // if (IACBus01) {
        //   IACBus01.addListener(
        //     "noteon",
        //     "all",
        //     this.handleIACBus01NoteOn.bind(this)
        //   );
        //   IACBus01.addListener(
        //     "noteoff",
        //     "all",
        //     this.handleIACBus01NoteOff.bind(this)
        //   );
        // }
      }
    });
  }

  handleIACBus01NoteOn(e) {}

  handleIACBus01NoteOff(e) {}

  getRGBValue(val) {
    return scale(val, 0, 127, 0, 255);
  }

  render() {
    if (WebMidi.supported) {
      return html`
      <div>HI</div>
        ${this.availableInputs.map((input) => html`<div>${input}</div>`)}
      `;
    } else {
      return html`web midi not supported`;
    }
  }
}

customElements.define("midi-container", MidiContainer);
